<template>
    <div class="animated fadeIn">
        <component-header
            title="FAQ Master Config"
            :isLoading="loading"
            @search-query="(val) => (filter = val)"
            @create-press="$router.push({ name: 'CreateFaq' })"
            createButtonText="Create FAQ"
            @reload-data="getFaqsList"
            :hasClear="false"
        />
        <b-card class="card-wrap" border-variant="info">
            <div class="mt-2 faqdetailTable">
                <div class="table-wrapper">
                    <b-table
                        class="faq-table mt-3 tableRadius"
                        :dark="dark"
                        :hover="hover"
                        :striped="striped"
                        :bordered="bordered"
                        :small="small"
                        :fixed="fixed"
                        responsive
                        id="my-table"
                        :current-page="currentPage"
                        :per-page="perPage"
                        :items="faqs"
                        thead-class="header"
                        :fields="Columns"
                        show-empty
                        :busy="loading"
                        :sort-by.sync="sortBy"
                        :sort-desc.sync="sortDesc"
                    >
                    <template slot="cell(action)" slot-scope="data">
                        <div class="inline_btnTable">
                            <ActionButtonGroup
                                showView
                                showEdit
                                showDelete
                                @view="navigateTo(data, 'view')"
                                @edit="navigateTo(data, 'edit')"
                                @delete="deleteFaq(data)"
                            />
                        </div>
                    </template>
                    </b-table>
                </div>
                <div class="pagination-wrapper" v-if="faqs.length > 0">
                    <b-pagination
                        v-model="currentPage"
                        :per-page="perPage"
                        :total-rows="faqs.length"
                        aria-controls="my-table"
                        prev-text="Prev"
                        next-text="Next"
                        hide-goto-end-buttons
                    ></b-pagination>
                </div>
            </div>
        </b-card>
    </div>
</template>
<script>
import ComponentHeader from "@/components/componentNewHeader";
import ActionButtonGroup from "@/components/Common/ActionButtonGroup.vue";
export default {
    name: "faqdetails",
    components: {
        ComponentHeader,
        ActionButtonGroup,
    },
    data() {
        return {
            filter: "",
            loading: false,
            perPage: 5,
            hover: true,
            striped: false,
            bordered: true,
            small: false,
            dark: false,
            fixed: false,
            currentPage: 1,
            sortBy: "createdAt",
            sortDesc: true,
            Columns: [
                {
                    key: "category",
                    sortable: true,
                },
                {
                    key: "Topic",
                },
                {
                    key: "Description",
                },

                {
                    key: "action",
                    class: "text-center",
                },
            ],
        };
    },
    computed: {
        faqs() {
            let data = this.$store.getters["faq/GetFaqList"];
            let faqList = [];
            if (Array.isArray(data) && data.length > 0) {
                data.forEach((obj) => {
                    for (let i = 0; i < obj.items.length; i++) {
                        let arrayObj = {
                            _id: obj._id,
                            category: obj.category,
                            Topic: obj.items[i].topic,
                            Description: obj.items[i].description,
                            item_id: obj.items[i]._id,
                            ...obj,
                        };
                        faqList.push(arrayObj);
                    }
                });
                const query = this.filter.toLowerCase();
                if (!query) return faqList;
                return faqList.filter((el) => {
                    const category = (el.category || "").toLowerCase();
                    const topic = (el.Topic || "").toLowerCase();
                    const description = (el.Description || "").toLowerCase();
                    return (
                        category.includes(query) ||
                        topic.includes(query) ||
                        description.includes(query)
                    );
                });
            } else {
                return [];
            }
        },
    },
    methods: {
        async getFaqsList() {
            this.loading = true;
            try {
                const data = await this.$store.dispatch("faq/fetchFaqsList");
                if (data.message) {
                    this.$toasted.error(data.message);
                }
            } finally {
                this.loading = false;
            }
        },
        navigateTo(data, type) {
            let obj = {
                ...data.item,
            };
            data.item.items.forEach((el) => {
                if (data.item.item_id === el._id) {
                    obj.mediaType = el.media.mediaType;
                    obj.mediaContent = el.media.mediaContent;
                }
            });
            this.$store.dispatch("faq/sendFaqData", obj);
            if (type === "edit") {
                this.$router.push({ name: "EditFaq" });
                return;
            }
            if (type === "view") {
                this.$router.push({ name: "ViewFaq" });
                return;
            }
        },
        async deleteFaq(data) {
            this.$swal({
                title: "Delete this FAQ?",
                text: "Are you sure? You won't be able to revert this!",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                confirmButtonText: "Yes, Delete it!",
                cancelButtonColor: "#d33",
                reverseButtons: true,
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch(
                            "faq/deleteFaq",
                            data.item._id + "/" + data.item.item_id,
                        )
                        .then((result) => {
                            this.$toasted.success("Faq Deleted Successfully");
                            this.$store
                                .dispatch(
                                    "faq/fetchFaqsList",
                                    this.$store.getters["auth/getUserID"],
                                )
                                .catch((error) => {
                                    this.$toasted.error(error.message);
                                });
                        });
                }
            });
        },
    },
    async mounted() {
        // await this.$store.dispatch("faq/fetchFaqsList").then((data) => {
        //   if (data.message) {
        //     this.$toasted.error(data.message);
        //   } else {
        //   }
        // });
       this.getFaqsList();
    },
};
</script>
<style scoped>
.table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
}

.faq-table {
    border-radius: 12px;
}

.edit {
    color: white !important;
}

.edit-btn-orange {
    background: #fe7b08;
    border: #fe7b08;
}

.edit-btn-orange:hover {
    background: #e66a00;
    border-color: #e66a00;
}

.inline_btnTable {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 6px;
}

.inline_btnTable .button-circle {
    flex-shrink: 0;
    margin-right: 0 !important;
    margin-left: 0 !important;
}

.text-center {
    text-align: center;
}

.form-div label {
    margin-top: 8px;
}

.faqdetailTable >>> .table th {
    min-width: 100%;
}

.pagination-wrapper {
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;
}

@media (max-width: 991.98px) {
    .inline_btnTable {
        display: inline-flex;
        flex-wrap: nowrap;
    }

    .inline_btnTable .button-circle {
        min-width: auto;
        padding: 0.25rem 0.5rem;
    }

    .inline_btnTable .mr-2 {
        margin-right: 0 !important;
    }
}

@media (max-width: 767.98px) {
    .pagination-wrapper {
        justify-content: center;
    }

    .table-wrapper {
        margin: 0 -15px;
    }

    .inline_btnTable {
        display: inline-flex;
        flex-wrap: nowrap;
    }

    .inline_btnTable .button-circle {
        padding: 0.2rem 0.4rem;
        font-size: 0.875rem;
    }

    .inline_btnTable .mr-2 {
        margin-right: 0 !important;
    }
}

@media (max-width: 575.98px) {
    .inline_btnTable {
        gap: 4px;
    }
}
</style>
